import GeocodeEarth from '@qonto/ui-kit/services/geocode-earth';

export default GeocodeEarth;
